import { ApiFunc, getInstance } from '../../../helpers/httpClient'
import * as API from '../constants/api'

const instance = getInstance()

export const chatMessageAll: ApiFunc<`${typeof API.CHAT_MESSAGE_ALL}`, 'get'> = data =>
  instance.get(API.CHAT_MESSAGE_ALL, {
    params: data,
  })

export const chatMessageList: ApiFunc<`${typeof API.CHAT_MESSAGE}`, 'get'> = data =>
  instance.get(API.CHAT_MESSAGE, {
    params: data,
  })

export const chatMessagePost: ApiFunc<`${typeof API.CHAT_MESSAGE}`, 'post'> = data =>
  instance.post(API.CHAT_MESSAGE, data)
